export type ThemePreference = 'system' | 'light' | 'dark';
const KEY = 'chipn-theme';

export function getThemePreference(): ThemePreference {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(pref: ThemePreference): void {
  const dark =
    pref === 'dark' || (pref === 'system' && matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.classList.toggle('dark', dark);
  try {
    localStorage.setItem(KEY, pref);
  } catch {
    // Private mode: the choice simply is not remembered.
  }
}

/** Keeps the page in sync with the OS setting while the preference is "system". */
export function watchSystemTheme(): () => void {
  const mq = matchMedia('(prefers-color-scheme: dark)');
  const onChange = () => getThemePreference() === 'system' && applyTheme('system');
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}
